const state = {
  from: '',
  to: ''
}

export default state
